@if (display) {
	<p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
		header="{{ title }}"
		[(visible)]="display"
		[responsive]="true"
		showEffect="fade"
		[modal]="true"
		appendTo="body"
	>
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
		<!-- #region BODY -->
		<div class="container-md">
			<div class="ui-grid-row">
				<div class="ui-grid-col-12">
					<p-messages [(value)]="messages"></p-messages>
				</div>
			</div>
			<!-- NAME -->
			<div class="row mt-3">
				<div class="col-12">
					<label for="cardType-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.breakdown.breakdownReason.reason' | translate }}
					</label>
					<input
						[disabled]="!formManipulation"
						type="text"
						id="cardType-name"
						class="form-control custom-input"
						[(ngModel)]="entity.reason"
					/>
				</div>
			</div>
			<!-- ACTIVE -->
			@if (!isNew) {
				<div class="row mt-3">
					<div class="col-12">
						<label for="cardType-enabled" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'general.active' | translate }}
						</label>
						<input
							class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
							type="checkbox"
							[(ngModel)]="active"
							[disabled]="true"
						/>
					</div>
				</div>
			}
		</div>
		<!-- #endregion BODY -->
	</div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
			<div class="d-flex justify-content-center bd-highlight">
				<div class="p-2 bd-highlight">
					@if (isNew) {
						<div>
							<button class="btn custom-button" (click)="save()" [disabled]="!formManipulation" i18n>
								{{ 'general.create' | translate }}
							</button>
						</div>
					}
					@if (!isNew) {
						<div>
							<button class="btn custom-button" (click)="save()" [disabled]="!formManipulation" i18n>
								{{ 'general.save' | translate }}
							</button>
						</div>
					}
				</div>
				<div class="p-2 bd-highlight">
					@if (!isNew) {
						<div>
							<button class="btn custom-button" (click)="changeStatus(active)" [disabled]="!disableGranted" i18n>
								{{ 'general.changeStatus' | translate }}
							</button>
						</div>
					}
				</div>
			</div>
		</ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}
